export default object =>
  Object.entries(object).reduce((q, [key, value], i) => {
    const k = encodeURIComponent(key);
    const v = encodeURIComponent(value);
    return `${q}${i > 0 ? '&' : '?'}${k}=${v}`;
  }, '');
